import Field from '../stores/field';
import * as API_REQ from '../apis/req';
import src from './public/source';
import { getEcCom,getLabel } from './convert';

/************ index内调用init初始化，store内部就可实现互相调用 ************/
const base = {
    globalStore: {},
    layoutStore: {},
    ehOperatorStore: {},
    printLogStore: {},
    rejectStore: {},
    shareStore: {},
    overTimeStore: {},
    freeFlowStore: {},
    secondAuthStore : {},
    selectNextFlowStore: {},
    followSelectStore:{},
    freeWflowSimpleStore:{},
    ensureSubmitStore: {},
    smartGuessWfStore: {},
    requestWithdrawStore: {},
    showContentStore: {},
	conformRuleStore: null,
    init: function(stores){
        this.globalStore = stores.globalStore;
        this.layoutStore = stores.layoutStore;
        this.ehOperatorStore = stores.ehOperatorStore;
        this.printLogStore = stores.printLogStore;
        this.rejectStore = stores.rejectStore;
        this.shareStore = stores.shareStore;
		this.selectNextFlowStore = stores.selectNextFlowStore;
        this.overTimeStore = stores.overTimeStore;
        this.freeFlowStore = stores.freeFlowStore;
        this.secondAuthStore = stores.secondAuthStore;
        this.followSelectStore = stores.followSelectStore;
        this.freeWflowSimpleStore = stores.freeWflowSimpleStore;
        this.ensureSubmitStore = stores.ensureSubmitStore;
        this.smartGuessWfStore = stores.smartGuessStore;
        this.requestWithdrawStore = stores.requestWithdrawStore;
        this.showContentStore = stores.showContentStore;
		this.conformRuleStore = stores.conformRuleStore;
        //公共util数据源source做初始化
        src.init(stores.globalStore, stores.layoutStore, Field, API_REQ, getLabel);
    },
}

export default base;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/util/base.js